module.exports = __webpack_public_path__ + "img/footer-icon.a868ec3f.png";